import {Pipe, PipeTransform} from '@angular/core';
import {EventType} from '../models/flow';
import {isRetiredEventType} from '../utils/flow-utils';

@Pipe({
  name: 'serviceOrderState',
  standalone: false
})
export class ServiceOrderStatePipe implements PipeTransform {
  transform(status: string, events: EventType[]): { name: string, class: string, icon: string } {
    const event = events.find(e => e.id.toString() === status);

    if (event?.name === 'Orden creada') event.color = '#FF990A';
    if (event?.name === 'Orden finalizada') event.color = '#45A557';

    // Etapa retirada del flujo: la SO sigue parada ahi hasta que el backend la
    // reproyecte, asi que se muestra el nombre real en gris en vez de un error.
    if (event && isRetiredEventType(event)) {
      return {name: `${event.name} (retirada)`, class: 'subtle-grey', icon: event.icon || ''};
    }

    if (event) {
      let clase: string;
      switch (event.color) {
        case '#0072F5':
          clase = 'subtle-blue';
          break;
        case '#A8A8A8':
          clase = 'subtle-grey';
          break;
        case '#8E4EC6':
          clase = 'subtle-purple';
          break;
        case '#FF990A':
          clase = 'subtle-amber';
          break;
        case '#E5484D':
          clase = 'subtle-red';
          break;
        case '#EA3E83':
          clase = 'subtle-pink';
          break;
        case '#45A557':
          clase = 'subtle-green';
          break;
        case '#12A594':
          clase = 'subtle-teal';
          break;
        default:
          clase = 'black';
          break;
      }
      return { name: event.name, class: clase, icon: event.icon || '' }
    } else {
      return { name: 'Estado no válido', class: 'black', icon: '' };
    }
  }
}
